// client/src/components/Finances/SummaryStrip.js

export default function SummaryStrip({ summary }) {
  if (!summary) {
    return (
      <div className="text-sm text-gray-500 p-4">
        No financial summary available.
      </div>
    );
  }

  const {
    totalMonthlyCost,
    mortgage,
    valuation,
    equity
  } = summary;

  const safeNumber = (n) =>
    Number(n || 0).toLocaleString();

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

      {/* TOTAL MONTHLY COST */}
      <div className="bg-white shadow-sm rounded-xl p-4">
        <p className="text-gray-500 text-sm">Total Monthly Cost</p>
        <p className="text-2xl font-bold">
          ${safeNumber(totalMonthlyCost)}
        </p>
      </div>

      {/* MORTGAGE SNAPSHOT */}
      <div className="bg-white shadow-sm rounded-xl p-4">
        <p className="text-gray-500 text-sm">Mortgage</p>
        <p className="font-semibold">
          ${safeNumber(mortgage?.balance)}
        </p>
        <p className="text-xs text-gray-600">
          Rate: {mortgage?.rate ? `${mortgage.rate}%` : "N/A"}
        </p>
      </div>

      {/* PROPERTY VALUE */}
      <div className="bg-white shadow-sm rounded-xl p-4">
        <p className="text-gray-500 text-sm">Property Value</p>
        <p className="text-xl font-bold">
          ${safeNumber(valuation?.estimate)}
        </p>
      </div>

      {/* NET EQUITY */}
      <div className="bg-white shadow-sm rounded-xl p-4">
        <p className="text-gray-500 text-sm">Net Equity</p>
        <p className="text-xl font-bold">
          ${safeNumber(equity)}
        </p>
      </div>

    </div>
  );
}
